<template lang="pug">
  main
    NavBarAccesos
    Loader(v-show="isLoading")
    section.section(v-show="!isLoading")
      .container(v-show="!salio")
        .columns
          .column.is-offset-one-quarter-tablet.is-half-tablet
            h4.title Estatus {{tanqueSalida.pg}}
              | &nbsp
              router-link.a.button.is-dark.is-rounded.is-size-6.is-medium(to="/TPA/SCA/Accesos")
                i.fas.fa-times
      .container(v-show="puedeSalir")
        .columns.has-text-centered
          .column.is-offset-one-quarter-tablet.is-half-tablet
            textarea.textarea(
              v-model="txtObservaciones",
              placeholder='Observaciones', 
              rows='3'
            )
        .columns.has-text-centered
          .column.is-offset-one-quarter-tablet.is-half-tablet
            .field
              p.has-text-gray 
                b ¿Emplazado?
                input#emplazadoY.is-checkradio.is-primary(type='radio', value='0' v-model='emplazado' checked='checked')
                label.is-size-6(for='emplazadoY') 
                  b NO
                input#emplazadoN.is-checkradio.is-danger(type='radio', value='1' v-model='emplazado')
                label.is-size-6(for='emplazadoN') 
                  b SI
        .columns.has-text-centered
          .column.is-offset-one-quarter-tablet.is-half-tablet
            button.button.is-primary(@click="guardarSalida()" v-show="puedeSalir") Guardar
      .container(v-show="!puedeSalir")
        .columns.has-text-centered
          .column.is-offset-3.is-6
            span(v-html="obtenerDataEstado()")
        .columns.column-blanco
      .container(v-show="salio")
        .columns
          .column.is-offset-one-quarter-tablet.is-half-tablet
            h4.title Salida de {{tanqueSalida.pg}}
              | &nbsp
              router-link.a.button.is-dark.is-rounded.is-size-6.is-medium(to="/TPA/SCA/Accesos")
                i.fas.fa-times
            .card.has-text-centered.is-wide
              header.card-header
                b.subtitle Autotanque {{ tanqueSalida.pg }}
              .card-content
                h1
                  | {{ tanqueSalida.pg }}
                p
                  i
                    | {{ tanqueSalida.fechaSalida }}
                span.tag.is-medium.is-danger(v-if="tanqueSalida.emplazado === '1'") Emplazado
                span.tag.is-medium.is-primary(v-else) Salida Normal
              footer.card-footer
                router-link.a.button.is-dark.is-rounded.is-size-6.is-small(to="/TPA/SCA/Accesos") ir a Recepción
        .columns.column-blanco
</template>
<script>
import NavBarAccesos from '@/components/sca_Componentes/acceso/layout/NavBarAccesos.vue'
import Loader from '@/components/shared/Loader.vue'
import TypeaheadPG from '@/components/sca_Componentes/acceso/shared/TypeaheadPG.vue'
import moment from 'moment'

import autotanquesServicesIRGE from '@/services/irge/autotanquesIRGE.js'
import { mapState } from 'vuex'
export default {
  name: 'Salidas',
  components: { Loader, TypeaheadPG, NavBarAccesos },
  data () {
    return {
      txtObservaciones: '',
      isLoading: true,
      emplazado: '',
      salio: false,
      puedeSalir: false
    }
  },
  methods: {
    checkSalida () {
      console.log(this.tanqueSalida.estado)
      switch (this.tanqueSalida.estado) {
        case '0':
          this.salio = false
          break
        case '1':
          this.salio = false
          break
        case '2':
          this.salio = false
          break
        case '3':
          this.salio = false
          break
        case '4':
          this.salio = false
          break
        case '5':
          this.puedeSalir = true
          this.salio = false
          break
        case '6':
          this.salio = true
          this.puedeSalir = true
          break
        case '7':
          this.salio = true
          this.puedeSalir = false
          break
      
        default:
          break
      }
      setTimeout(() => {
        this.isLoading = false
      }, 350)
    },
    guardarSalida () {
      this.isLoading = true
      console.log(this.txtObservaciones)
      if (this.tanqueSalida.estado === '6' || this.tanqueSalida.estado === '5') {
        let fechaReg = moment().format('YYYY-MM-DD HH:mm:ss')
        autotanquesServicesIRGE.salidaAutotanque(this.tanqueSalida.idPuntos, this.txtObservaciones, this.emplazado, fechaReg)
          .then(data => {
            console.log(data)
            if (data.success) {
              autotanquesServicesIRGE.finishRecepcion(this.tanqueSalida.id, this.userLogin.id, this.userLogin.nombre, fechaReg, this.userLogin.id, this.userLogin.nombre)
                .then(res => {
                  console.log(res)
                  if (res.success) {
  
                    autotanquesServicesIRGE.getIdEmbarque(this.tanqueSalida.idPuntos, this.tanqueSalida.pg)
                      .then( resIE => {
                        console.log(resIE)
  
                        if (resIE.length > 0) {
                          let idEmb = resIE[0].idEmbarque
                          console.log(idEmb)
                          autotanquesServicesIRGE.updateEmbarque_salida(idEmb, fechaReg)
                            .then( resSalida => {
                              console.log(resSalida)
                              if (resSalida.success) {
                                console.log(resSalida.respuesta)
                              } else {
                                console.log(resSalida.respuesta)
                              }
                            })
                        } else {
                          console.log('IdEmbarque No encotnrado =(')
                        }
                        setTimeout(() => {
                          this.isLoading = false
                          this.$router.push('/IRGE/Accesos_IRGE')
                        }, 500)
                      })
  
                  } else {
                    console.log(res.respuesta)
                  }
                })
            } else {
              console.log(data.respuesta)
            }
          })
      } else {
        let toast = this.$toasted.show(`El autotanque No puede salir, aún no termina su documentación.`, { 
            theme: "toasted-primary", 
            position: "bottom-right", 
            duration : 3000,
            iconPack: 'fontawesome',
            icon: 'exclamation-circle',
            action : {
              text : 'Ok',
              onClick : (e, toastObject) => {
                toastObject.goAway(0)
              }
            },
          })
      }
    },
    isEmplazado (emplazado) {
      if (emplazado === '1') {
        return true
      } else {
        return false
      }
    },
    obtenerDataEstado() {
      let texto = ''
      switch (this.tanqueSalida.estado) {
        case '0':
          texto = `<div class="notification is-primary">
            El autotanque <strong>${this.tanqueSalida.pg }</strong>, ha llegado a la Terminal.
          </div>`
          break
        case '1':
          texto = `<div class="notification is-primary">
            El autotanque <strong>${this.tanqueSalida.pg }</strong>, ha ingresado a la Terminal.
          </div>`
          break
        case '2':
          texto = `<div class="notification is-primary">
            El autotanque <strong>${this.tanqueSalida.pg }</strong>, ha entrado a Llenaderas.
          </div>`
          break
        case '3':
          texto = `<div class="notification is-primary">
            El autotanque <strong>${this.tanqueSalida.pg }</strong>, esta en cargando producto.
          </div>`
          break
        case '4':
          texto = `<div class="notification is-primary">
            El autotanque <strong>${this.tanqueSalida.pg }</strong>, ha finalizado la carga de producto.
          </div>`
          break
        case '5':
          texto = `<div class="notification is-primary">
            El autotanque <strong>${this.tanqueSalida.pg }</strong>, ha documentado su salida.
          </div>`
          break
        case '6':
          texto = `<div class="notification is-primary">
            El autotanque <strong>${this.tanqueSalida.pg }</strong>, ha tramitado su factura.
          </div>`
          break
      
        default:
          break
      }
      return texto
    }
  },
  created () {
    this.checkSalida()
    // this.obtenerDatosTanque(this.tanqueSalida)
  },
  computed: {
    ...mapState(['tanqueSalida', 'userLogin'])
  }
}
</script>

<style lang="scss" scoped>
  .card.is-wide {
    width: 550px;
  }

  .column-blanco {
    padding-bottom: 100px;
  }

  .card.has-text-centered {
    .card-header,
    .card-content,
    .card-footer {
      justify-content: center;
      align-items: center;
    }
    
    h1 {
      font-size: 1.75rem;
      font-weight: bold;
    }
  }

  .card-header {
    padding: 1.75rem 0;
  }

  .card-content {
    padding: 3.5rem 0;
  }

  .card-footer {
    padding: 1rem 0;
    border: none;
    font-size: .9rem;
    color: lighten(black, 50%);
  }
</style>





// WEBPACK FOOTER //
// src/components/sca_Componentes/acceso/Salida.vue